(function ($) {

$.fn.qtip.styles.wallets = { // Last part is the name of the style
	width: 170,
	background: '#000000',
	color: '#ffffff',
	border: {
		width: 1,
		radius: 5,
		color: '#000000'
	},
	tip: {
		corner: 'bottomLeft',
		size: {
						x: 15,
						y: 20
				 }
	}
}
$.fn.qtip.styles.notesbottom = { // Last part is the name of the style
    width: 170,
	background: '#000000',
	color: '#ffffff',
	border: {
		width: 1,
		radius: 5,
		color: '#000000'
	},
	tip: {
		corner: 'topLeft',
		size: {
						x: 15,
						y: 20
				 }
	}
}


$(document).ready(function() {
	var shopIdentifier = "AU";
	var usCodes = ["US", "CA", "MX", "BZ", "CR", "SV", "GT", "HN", "NI", "PA", "AR", "BO", "BR", "CL", "CO", "EC", "GY", "PY", "PE", "SR", "TT", "UY", "VE"];

	function setCookieAndRedirect(identifier) {
	  var expires = new Date();
	  expires.setFullYear(expires.getFullYear() + 1);
		$.cookie("preferred-shop", identifier, {domain: "bellroy.com", expires: expires, path: '/'});
		var href = location.href.replace(/http:\/\/[^.]+/, "http://" + identifier.toLowerCase());
		location.href = href;
	}

	if ($.cookie("preferred-shop") == null) {

		// redirect user according to his current country
		$.getJSON("http://orders.bellroy.com/country.js?callback=?", function(data) {
		  var country = data.country_code || "AU";
			var USCountry = $.inArray(country, usCodes) != -1;

			if (shopIdentifier == "US" && !USCountry) {
				setCookieAndRedirect("AU");
			}
			else if (shopIdentifier == "AU" && USCountry) {
				setCookieAndRedirect("US");
			}
		});
	}
	else if ($.cookie("preferred-shop") != shopIdentifier) {
		setCookieAndRedirect($.cookie("preferred-shop"));
	}

	// Change country when choosing currency from drop down menu
	$("#shop-currency").change(function() {
		setCookieAndRedirect($(this).val().substr(0, 2));
	});

	// Break out of fancybox iframe if not in cart
	if ($('body').attr('class') != 'cart') {
		if (top.location != self.location) {
			top.location = self.location;
		}
	}


	// Swap default form values to empty when selected and vice-versa
	$('input[type="text"],textarea').focus(function() {
		if (this.value == this.defaultValue) {
			this.value = '';
		}
	});
	$('input[type="text"],textarea').blur(function() {
		if ($.trim(this.value) == '') {
			this.value = (this.defaultValue ? this.defaultValue : '');
		}
	});


	// Simple check to prevent form submission if fields aren't filled out
	// Used for forms where every field is required
	// Enter form selectors into line below
	var shouldSubmitForm = function(form) {
		var hasDefaultValue = false;
		$(':input[type="text"],:input[type="textarea"]',$(form)).each(function () {
			if (this.value == this.defaultValue) {
				hasDefaultValue = true;
				return false;
			}
		});
		return hasDefaultValue ? false : true;
	};

	$('#search form, #mailing-list form, form.contact').submit(function(e) {
		if(!shouldSubmitForm(this)) {
			e.stopImmediatePropagation();
			return false;
		}
	});


	// Content slider on homepage
	// Uses Looped Slider plugin
	$('#feature').loopedSlider({
		autoStart: 10000,
		containerClick: false,
		slidespeed: 1500,
		restart: 4000
	});


	// Wallet Range - highlight product title
	// Adds and removes hover class, finds class using rel value
	$('#rangeMap area').hover(
		function() {
			$('#wallets ul li.' + $(this).attr('rel') + ' a').addClass('hover');
		},
		function() {
			$('#wallets ul li.' + $(this).attr('rel') + ' a').removeClass('hover');
		}
	);


	// Wallet Range - tooltips
	// Uses qTip plugin
	// Grabs HTML content for tooltip from product titles below
	$('#rangeMap area').each(function() {
		$(this).qtip({
			content: $('#wallets ul li.' + $(this).attr('rel') + ' a').html(),
			show: 'mouseover',
			hide: 'mouseout',
			position: {
				adjust: { x: 0, y: 50 },
				corner: {
					target: 'topMiddle',
					tooltip: 'bottomLeft'
				}
			},
			style: { name: 'wallets' }
		});
	});
    $('#wallets a.folded-notes').each(function() {
		$(this).qtip({
			content: $('#wallets div.' + $(this).attr('rel')).html(),
			show: 'mouseover',
			hide: 'mouseout',
			position: {
				adjust: { x: 35, y: 15 },
				corner: {
					target: 'topLeft',
					tooltip: 'bottomLeft'
				}
			},
			style: { name: 'wallets' }
		});
	});
    $('#wallets a.flat-notes').each(function() {
    	$(this).qtip({
			content: $('#wallets div.' + $(this).attr('rel')).html(),
			show: 'mouseover',
			hide: 'mouseout',
			position: {
				adjust: { x: 35, y: 0 },
				corner: {
					target: 'bottomLeft',
					tooltip: 'topLeft'
				}
			},
			style: { name: 'notesbottom' }
		});
	});
    $('#wallets a.notes').click(function() {
        return false;
    });

	// Product details page - image swapper
	// Swaps main image when thumbnail is clicked
	$('ul#product-thumbs li a').click(function() {
		$('#main-image img').hide();
		$('#main-image').addClass('loading');

		$('ul#product-thumbs li a').removeClass('selected');
		$(this).addClass('selected');

		var swapimg = $(this).attr('href');
		$('#main-image img').attr('src', swapimg);
		$('#main-image img').load(function () {
			$('#main-image img').show('fast',function() {
				$('#main-image').removeClass('loading');
			});
		});

		//var swapimg = $(this).attr('href');
		//$('#main-image img').attr('src', swapimg);

		return false;
	});


	// Product details page - option selector
	// Adds class to swatch image when label is clicked
	// Selective display of images depending on selected color
if ( $('div.color').length > 0 ) {
    var selectedColor = $('div.color ul li input:checked').attr('class');
    $('ul#product-thumbs li').hide();
    $('ul#product-thumbs li[class|="' + selectedColor + '"]').show();
}

	$('div.color ul li label').click(function() {
		$('div.color ul li label span.swatch').removeClass('selected');
		$(this).children('span.swatch').addClass("selected");

    var selectedColor = $(this).attr('class');
    $('ul#product-thumbs li').hide();
    $('ul#product-thumbs li[class|="' + selectedColor + '"]').show();

		var swapimg_class = $(this).attr('class') + '-1';
		$('ul#product-thumbs li a.' + swapimg_class).trigger('click');
	});

	$('div.color ul li input').click(function() {
		$('div.color ul li label span.swatch').removeClass('selected');
		$(this).next('label').children('span.swatch').addClass("selected");

    var selectedColor = $(this).attr('class');
    $('ul#product-thumbs li').hide();
    $('ul#product-thumbs li[class|="' + selectedColor + '"]').show();

		var swapimg_class = $(this).next('label').attr('class') + '-1';
		$('ul#product-thumbs li a.' + swapimg_class).trigger('click');
	});


	// Product details page - 'Add to cart' targets hidden iframe and fires fancybox
	// Refreshes cart items count via AJAX when fancybox is closed
	$('body.product #footer').after('<div id="viewcart"><iframe id="popcart" name="popcart" src="about:blank" frameborder="0" style="border: 0;"></iframe>');
	$('body.product form#cart-add input#purchase').after('<a id="cartlink" href="#viewcart" style="display: none;">View Cart</a>');
	$('a#cartlink').fancybox({
		autoDimensions: false,
		height: 500,
		overlayOpacity: 0.5,
		scrolling: 'no',
		width: 900,
		onClosed: function() {
			$('#cart-items a').load('/cart #cart-items a');
		}
	});
	$('body.product form#cart-add').attr('target', 'popcart');
	$('body.product form#cart-add input#purchase').click(function() {
		$('a#cartlink').trigger('click');
	});


	// Open fancybox when cart is clicked
	// Refreshes cart items count via AJAX when fancybox is closed
	$('#cart-items a').fancybox({
		autoDimensions: false,
		height: 500,
		overlayOpacity: 0.5,
		type: 'iframe',
		width: 900,
		onClosed: function() {
			$('#cart-items a').load('/cart #cart-items a');
		}
	});


	// Cart - quantity adjust buttons
	$('form#cart a.increase').click(function() {
		var qty_value = parseInt($(this).parent('td.qty').children('input').attr('value'));
		if (!isNaN(qty_value)) {
			$(this).parent('td.qty').children('input').attr('value', qty_value + 1);
		}
		return false;
	});
	$('form#cart a.decrease').click(function() {
		var qty_value = parseInt($(this).parent('td.qty').children('input').attr('value'));
		if (!isNaN(qty_value) && qty_value > 1) {
			$(this).parent('td.qty').children('input').attr('value', qty_value - 1);
		}
		return false;
	});


	// Cart - continue shopping button
	$('body.cart a.continue').click(function() {
		window.top.window.$.fancybox.close();
		return false;
	});


	// Cart - break out of iframe when checkout is pressed
	$('form#cart input.checkout').click(function() {
		$('form#cart').attr('target', '_top');
	});
		


	// Carryology blog categories dropdown
	$('#carryology div.header #categories h4').click(function() {
		$(this).next('ul').slideToggle();
	});

	// Populate carryology posts on conversation page
	if($("#posts").length > 0) {
		var feed = new google.feeds.Feed("http://www.carryology.com/?feed=images-feed");
		feed.setNumEntries(8);
		feed.load(function(result) {
			if (!result.error) {
				var container = $("#posts");
				container.empty();

				for (var i = 0; i < result.feed.entries.length; i++) {
					var entry = result.feed.entries[i];
					var post = $(
						'<div class="post"> \
							<h2><a href="#"></a></h2> \
							<div class="date"></div> \
							<a class="thumbnail"><img /></a> \
							<div class="content"></div> \
							<div class="category">Category: <a href="#"></a></div> \
							<a class="more" href="#" target="_blank">More</a> \
						</div>'
					);

					$("h2 a", post).html(entry.title);
					$("div.date", post).text(entry.publishedDate);
					$("a.more, a.thumbnail, h2 a", post).attr('href', entry.link).attr('target', '_blank');
					if(entry.categories.length > 0) {
						var category = entry.categories[0];
						var href = "http://www.carryology.com/category/"+ 
							category.replace(/\s+/g, '_').toLowerCase() +"/";
						$("div.category a", post).attr('href', href).text(category);
					}

					// Find and set the picture
					var content = $(entry.content);
					var post_img = content.find("img[src*='carryology-assets'], img[src*='www.carryology.com/wp-content/uploads/']").first();

					if(post_img.length) {
						// http://carryology-assets.s3.amazonaws.com/wp-content/uploads/2010/05/money-300x200.jpg
						var img_src = post_img.attr('src');

						if(entry.mediaGroups) {
							var img_basename = img_src.replace(/\.[^.]+$/, "");
							var group = entry.mediaGroups[0];
							for(var media = 0; media < group.contents.length; media++) {
								if(group.contents[media].url.indexOf(img_basename) == 0) {
									// media.url begins with img_basename
									img_src = group.contents[media].url; 
									break;
								}
							}
						}

						$("a.thumbnail img", post).attr('src', img_src);
					}
					$("div.content", post).html(entry.contentSnippet);

					container.append(post);
				}
			}
		});
	}

	var isValidEmailAddress = function(emailAddress) {
		var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
		return pattern.test(emailAddress);
	}
	
	// Handle mailing list form submission
	$('#mailing-list form').submit(function() {
		var self = $(this);
		var email = self.find('#mailing-list-email').val();
		if(isValidEmailAddress(email)) {
			self.find("input[type='submit']").attr('value', 'Submitting...');
			$('#mailing-list form').hide();
			$('<p class="thanks">Thanks, we\'ve added you to the list.</p>')
				.insertAfter('#mailing-list form');
		}
		else {
			alert("'" + email	+ "' does not appear to be a valid email address.");
			return false;
		}
	});

	// Contact form
	$('form.contact').submit(function() {
		var self = $(this);
		var email = self.find('#contact_email').val();
		if(isValidEmailAddress(email)) {
			self.find("input[type='submit']").attr('value', 'Submitting...');
			$('form.contact').slideUp();
			$('<p class="thanks">Thank you, your enquiry has been been submitted.</p>').insertAfter('form.contact');
		}
		else {
			alert("'" + email	+ "' does not appear to be a valid email address.");
			return false;
		}
	});
});

})(jQuery);
